import bgMesh from "@/assets/bg-mesh.jpg";
import bgContour from "@/assets/bg-contour.jpg";

type HeroBackgroundProps = {
  variant?: "mesh" | "contour";
  /** Fade the gradient to transparent at the bottom — use when a decorative
   * element (e.g. a wave) overlaps the hero's lower edge. */
  fadeToTransparent?: boolean;
  /** Show the blue gradient tint over the texture (default true). Set false on
   * pages that should stay clean, e.g. the homepage which has its own wave. */
  gradient?: boolean;
};

/**
 * Visible-but-calm hero background: a soft blue gradient (the primary brand
 * tint) with a subtle abstract texture layered beneath it. Uses semantic
 * tokens so it renders correctly in light & dark mode.
 *
 * Hero bands only — never behind forms or body content, where senior
 * readability is the priority.
 */
export const HeroBackground = ({
  variant = "mesh",
  fadeToTransparent = false,
  gradient = true,
}: HeroBackgroundProps) => {
  const src = variant === "mesh" ? bgMesh : bgContour;
  const gradientClass = fadeToTransparent
    ? "bg-gradient-to-b from-primary/15 via-primary/10 to-transparent"
    : "bg-gradient-to-b from-primary/15 via-primary/10 to-background";

  return (
    <div className={`absolute inset-0 ${gradient ? "bg-background" : "bg-white"}`} aria-hidden="true">
      {gradient && (
        <>
          <img
            src={src}
            alt=""
            className="w-full h-full object-cover opacity-35"
            loading="lazy"
          />
          <div className={`absolute inset-0 ${gradientClass}`} />
        </>
      )}
    </div>

  );
};
